import type {Role} from "utils/roles";

export type AuthenticatedUser = {
  id: number;
  role: Role;
  is_reseller: boolean;
  account_id: number;
  token: string;
  email: string;
  phone: string;
  full_name: string;
};

const AuthModeLogin = "login";
const AuthModeSignup = "signup";
const AuthModeResetPassword = "reset_password";
export type AuthMode =
  | typeof AuthModeLogin
  | typeof AuthModeSignup
  | typeof AuthModeResetPassword;

export const AUTH_MODES = {
  LOGIN: AuthModeLogin as AuthMode,
  SIGNUP: AuthModeSignup as AuthMode,
  RESET: AuthModeResetPassword as AuthMode,
};
